<footer class="footer-content">
  <span>{{footerData}}</span>
</footer>